import React from 'react';
import CTSection from './CTSection';
import useNeuroState from '../../state';
import { ConversationTestModulePropTypes } from '../../utils';

const CTQuestionMap = ({ collapseBuilders, isFullHeight, width }) => {
  const { testPageData = {} } = useNeuroState();

  // eslint-disable-next-line react/prop-types
  const CTLink = ({ id, modifier }) => {
    const types = {
      path: {
        pre: 'Path: ',
        icon: '',
      },
      page: {
        pre: 'Page: ',
        icon: 'file-text',
      },
      question: {
        pre: '',
        icon: 'question-circle',
      },
    };
    const Component = modifier === 'question' ? 'a' : 'div';
    const icon = types[modifier].icon;
    const onClick = () => {
      const element = document.getElementById(`${id}-question`);
      element &&
        element.scrollIntoView &&
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
    };

    return (
      <Component
        onClick={onClick}
        className={`question__scroll-link question__scroll-link--${modifier}`}
      >
        {icon && <i className={`fa fa-${icon}`} aria-hidden="true" />}
        {types[modifier].pre && <b>{types[modifier].pre}</b>}
        {`${id}`}
      </Component>
    );
  };

  const renderQuestion = (question) => {
    return (
      <CTLink
        id={`${question.appkey}`}
        key={`${question.appkey}`}
        modifier="question"
      />
    );
  };

  const renderQuestionGroup = ({ questionGroup }) => {
    if (collapseBuilders && questionGroup.type === 'CardBuilder') {
      return (
        <React.Fragment key={`${questionGroup.questions[0].appkey}-container`}>
          {renderQuestion(questionGroup.questions[0])}

          {questionGroup.questions[0].answers.map((question) => {
            return (
              <CTLink
                id={`${question.key}`}
                key={`${question.key}`}
                modifier="card"
              />
            );
          })}
        </React.Fragment>
      );
    }

    return (questionGroup.questions || []).map((question) => {
      return renderQuestion(question);
    });
  };

  const questionFlowMap = (testPageData.questionPaths || []).map((path) => {
    return (
      <React.Fragment key={`link-${path.key}`}>
        <CTLink id={`${path.key}`} key={`${path.key}`} modifier="path" />
        {(path.pages || []).map((page) => {
          return (
            <React.Fragment key={`link-${page.key}`}>
              <CTLink id={`${page.key}`} key={`${page.key}`} modifier="page" />
              {(page.questionGroups || []).map((group) =>
                renderQuestionGroup({
                  questionGroup: group,
                  page,
                })
              )}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  });

  return (
    <CTSection
      isFullHeight={isFullHeight}
      className="question-map"
      title="Question Flow Map"
      width={width}
    >
      <div className="question-map__content">{questionFlowMap}</div>
    </CTSection>
  );
};

CTQuestionMap.propTypes = {
  ...ConversationTestModulePropTypes,
};

export default CTQuestionMap;
